import React, { Component, Fragment } from 'react';
import HTTP from '../../script/service';
import { Button, message } from 'antd';
import './applyAudio.scss';
import IframeModal from '../iframModal/IframModal';
import qs from 'qs';
import { _h5_link_to } from '../../store/Action';

export default class componentName extends Component {
  constructor(props) {
    super(props);
    this.state = {
      audioUrl: null,
      skillType: 1,
      time: 30,
    };
  }
  componentDidMount() {
    this.getPageData(this.props.skillType);
  }
  showModal = (skillType) => {
    this.getPageData(skillType);
  };
  hideModal = () => {
    this.setState({ visible: false }, () => {
      this.props.nextEvent && this.props.nextEvent();
    });
  };
  getPageData = (skillType) => {
    HTTP._get_StudyVedio({ uid: this.props.base.uid }).then((res) => {
      if (res.code == 200) {
        this.setState({ audioUrl: res.data, skillType });
      }
    });
  };
  iframeDestory = () => {
    window.removeEventListener('message', this.h5callback);
    HTTP._get_findGodApplyProgress({
      uid: this.props.base.uid,
      skillType: this.state.skillType,
    }).then((res) => {
      this.setState({ loading: false });
      if (res.code == 200) {
        this.setState({ applyProgress: res.data });
        if (res.data.videoStudy === 1) {
          // 答题正确直接跳转至下一步
          this.hideModal();
        }
      } else {
        message.warning(res.message);
      }
    });
  };
  h5callback = (key) => {
    // todo 需要调整 包含 H5（/questions-check）
    if (key?.data == 'destroy') {
      this.iframeElement.hideModal();
    }
  };
  toexam = (e) => {
    e.stopPropagation();
    const url = '/questions-check';
    _h5_link_to(url).then((res) => {
      res.params.skillType = this.state.skillType;
      this.setState({ loading: true });
      this.iframeElement.showModal(res.url + '?' + qs.stringify(res.params), {
        width: 500,
      });
      window.addEventListener('message', this.h5callback);
    });
  };
  changTime = () => {
    clearTimeout(this.timer);
    const { time } = this.state;
    if (time) {
      this.setState({ time: time - 1 }, () => {
        this.timer = setTimeout(this.changTime.bind(this), 1000);
      });
    }
  };
  onPause = () => {
    clearTimeout(this.timer);
  };
  onEnded = () => {
    this.setState({ time: 0 });
  };
  render() {
    const { audioUrl, time, applyProgress } = this.state;
    if (!audioUrl) return null;
    return (
      <Fragment>
        <div className="applyAudio-box">
          <div className="au-title">大神基础知识讲解，请认真学习哦~</div>
          <div className="audio-box">
            {audioUrl ? (
              <video
                preload="metadata"
                width="600"
                height="300"
                src={audioUrl}
                onEnded={this.onEnded}
                onPause={this.onPause}
                onPlay={this.changTime}
                autoPlay
                controls
              ></video>
            ) : null}
          </div>
          <div className="sub-title-1">《大神学院—平台基础知识》</div>
          <div className="sub-title-2">提示：观看视频后须完成试题考核哦~</div>
          {applyProgress ? (
            <div className="form-submits">
              {applyProgress.videoStudy == 1 ? (
                <Button
                  onClick={this.hideModal}
                  className="daidai-btn-primary"
                >
                  下一步
                </Button>
              ) : (
                <Button
                  onClick={this.toexam}
                  loading={this.state.loading}
                  className="daidai-btn-primary"
                >
                  未通过考核，继续考核
                </Button>
              )}
            </div>
          ) : (
            <div className="form-submits">
              {time ? (
                <Button
                  disabled={true}
                  className="daidai-btn-primary"
                >
                  完成学习，去考核（{time}s）
                </Button>
              ) : (
                <Button
                  onClick={this.toexam}
                  loading={this.state.loading}
                  className="daidai-btn-primary"
                >
                  完成学习，去考核
                </Button>
              )}
            </div>
          )}
        </div>
        {/* 通用H5弹窗 */}
        <IframeModal
          wrappedComponentRef={(el) => (this.iframeElement = el)}
          destroy={this.iframeDestory}
        />
      </Fragment>
    );
  }
}
